import { useEffect, useMemo } from "react"
import { MaterialReactTable, type MRT_ColumnDef } from "material-react-table"
import { Box } from "@mui/material"
import { useSelector } from "react-redux"
import SortIcon from "@mui/icons-material/Sort"
import SyncAltIcon from "@mui/icons-material/SyncAlt"
import ProvidersCell from "../Cell/ProvidersCell"
import ProvidersGroupCell from "../Cell/ProvidersGroupCell"
import { colors } from "../../../../styles/commonStyles"
import { roundUp } from "../../../../helper/utils/formatting"
const ProvidersTable = (props: any) => {
  const providersTableData = useSelector((state: any) => {
    return state.providers.providersTableData
  })
  const allProviderColumns = useSelector((state: any) => {
    return state.providers.allProviderColumns
  })
  const selectedProviderColumns = useSelector((state: any) => {
    return state.providers.selectedProviderColumns
  })
  const selectedProvidersMetricTab = useSelector((state: any) => {
    return state.providers.selectedProvidersMetricTab
  })

  const loading = useSelector((state: any) => {
    return state.app.isLoading
  })

  const headersToCapsLock = ["Cytd", "Py", "pytd", "ttm"]

  const capitalizeMatchingWord = (sentence: string) => {
    // Split the sentence into words
    const words = sentence.split(/\s+/)
    // Iterate over each word in the sentence
    const capitalizedWords = words.map((word) => {
      // Check if the word exists in the headersToCapsLock array
      const matchIndex = headersToCapsLock.findIndex(
        (header: any) => header.toLowerCase() === word.toLowerCase(),
      )

      // If the word exists in headersToCapsLock, capitalize it
      if (matchIndex !== -1) {
        return word.toUpperCase()
      }

      // Otherwise, return the word as is
      return word
    })
    // Join the words back into a sentence
    return capitalizedWords.join(" ")
  }

  let flatMetrics: any = []

  providersTableData?.data?.forEach((row: any) => {
    console.log("row", row.store_data)

    let tempRow: any = { ...row }
    row?.store_data?.forEach((column: any) => {
      tempRow[`${column?.column_id}_value`] = column?.column_value
    })
    flatMetrics.push(tempRow)
  })
  useEffect(() => {
    console.log("flatmetrics", flatMetrics)
  }, [flatMetrics])
  const providerColumns = selectedProviderColumns?.length
    ? selectedProviderColumns
    : allProviderColumns

  let dynamicColumns: MRT_ColumnDef<any>[] = providerColumns?.map(
    (column: any, index: number) => {
      const columnId = column?.column_id
      const columnHeader = column?.column_name

      return {
        header: columnHeader,
        id: columnId,
        accessorKey: `${column?.column_id}_value`,
        //size: 250,
        enableResizing: false,
        Header: ({ column }: any) => (
          <Box
            sx={{
              width: "100%",
              whiteSpace: "nowrap",
              paddingRight: "10px",
              textTransform: "capitalize",
            }}
          >
            {capitalizeMatchingWord(columnHeader)}
          </Box>
        ),
        Cell: ({ row, renderedCellValue }: any) => {
          if (renderedCellValue) {
            return (
              <Box
                sx={{
                  p: "10px",
                  py: "5px",
                  minWidth: "95%",
                  // display: "flex",

                  // border: "2px solid blue",
                  backgroundColor: row?.original?.store_data[index]
                    ?.column_color
                    ? row?.original?.store_data[index]?.column_color === "red"
                      ? colors.primaryRed
                      : colors.primaryGreen
                    : colors.primaryWhite,
                  color: row?.original?.store_data[index]?.column_color
                    ? colors.primaryWhite
                    : colors.primaryBlack,
                }}
              >
                {roundUp(
                  renderedCellValue,
                  row?.original?.store_data[index]?.column_datatype,
                  providersTableData?.metric_precision,
                )}
              </Box>
            )
          } else {
            return "-"
          }
        },
      }
    },
    [selectedProviderColumns],
  )

  const columns = useMemo<MRT_ColumnDef<any>[]>(() => {
    let localArr = [
      {
        accessorKey: "Group",
        header: "Group",
        enableSorting: false,
        Cell: ({ row }: any) => <ProvidersGroupCell row={row} />,
        enableResizing: false,
      },
      {
        accessorKey: "Provider",
        header: "Provider",
        enableResizing: false,
        enableSorting: false,
        Cell: ({ row }: any) => <ProvidersCell row={row} />,
      },
    ]

    dynamicColumns?.forEach((col: any) => {
      localArr?.push(col)
    })

    return localArr
  }, [allProviderColumns, selectedProviderColumns, selectedProvidersMetricTab])

  return providersTableData?.data?.length ? (
    <MaterialReactTable
      state={{
        isLoading: loading,
      }}
      columns={columns}
      data={flatMetrics}
      enableStickyHeader={true}
      enableColumnActions={false}
      enableColumnResizing={true}
      enableColumnFilters={false}
      enablePagination={false}
      enableSorting={true}
      enableBottomToolbar={false}
      enableTopToolbar={false}
      initialState={{
        columnPinning: {
          left: ["Group", "Provider"],
        },
      }}
      muiTableContainerProps={{
        sx: {
          height: "72vh",
          fontSize: 14,
          maxWidth: "100%",
          overflowX: "scroll",
        },
      }}
      muiTableBodyRowProps={{
        hover: false,
        sx: { height: "60px", width: "auto", borderLeft: "1px solid #000000" },
      }}
      muiTableHeadCellProps={{
        width: "auto",
        align: "center",
        sx: {
          maxHeight: "40px !important",
          backgroundColor: "#3366D6",
          color: "#FFFFFF",
          whiteSpace: "nowrap !important",
          borderRight: "0.5px solid #FFFFFF",
          boxShadow: " #00000022 1.95px  0px 2.6px",
        },
      }}
      muiTableBodyCellProps={{
        align: "center",
        sx: {
          whiteSpace: "nowrap",
          borderRight: `1px solid #E4E4E4`,
          boxShadow: " #00000022 1.95px  0px 2.6px",
        },
      }}
      icons={{
        ArrowDownwardIcon: (props: any) => {
          return <SortIcon sx={{ fill: "#fff" }} {...props} />
        },
        SyncAltIcon: (props: any) => {
          return <SyncAltIcon sx={{ fill: "#fff" }} {...props} />
        },
      }}
    />
  ) : (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      No Data
    </Box>
  )
}

export default ProvidersTable
